import { usePublicSettings } from "@/hooks/usePublicSettings";

export default function MaintenanceBanner() {
  const { settings } = usePublicSettings();
  const banner = (settings.MAINTENANCE_BANNER || "").trim();
  const mode = !!settings.MAINTENANCE_MODE;
  if (!banner && !mode) return null;
  const text = banner || "We're currently in maintenance mode. New renders are temporarily disabled.";
  return (
    <div
      data-testid="maintenance-banner"
      className={`w-full px-4 py-2 text-center text-xs sm:text-sm font-medium tracking-wide ${
        mode ? "bg-amber-500 text-amber-950" : "bg-brand-ink text-white"
      }`}
    >
      {mode && <span className="uppercase tracking-widest mr-2">Maintenance</span>}
      {text}
    </div>
  );
}
